import { z } from "zod";

export const LidarClearanceSystemSchema = z.object({
  region: z.string(),
  id: z.number(),
  name: z.string(),
  // The clearance rules config ds-lidar-pipeline reads for this system - see
  // Rules/clearanceRulesConfig.ts's hand-kept mirror of its actual shape.
  // Left loosely typed here since this schema only needs to pass it through.
  config: z.record(z.string(), z.unknown()).nullable(),
});
export type LidarClearanceSystem = z.infer<typeof LidarClearanceSystemSchema>;

export const LidarClearanceAxisSchema = z.object({
  region: z.string(),
  id: z.number(),
  name_en: z.string(),
  min_value: z.number(),
  max_value: z.number(),
  color_scale: z.number(),
  threshold_1: z.number(),
  threshold_2: z.number(),
  threshold_3: z.number(),
  threshold_4: z.number(),
});
export type LidarClearanceAxis = z.infer<typeof LidarClearanceAxisSchema>;

export const LidarClearanceSystemAxisSchema = z.object({
  region: z.string(),
  id: z.number(),
  system_id: z.number(),
  axis_id: z.number(),
  color_scale: z.number().nullable(),
});
export type LidarClearanceSystemAxis = z.infer<
  typeof LidarClearanceSystemAxisSchema
>;

export const LidarClearanceColorScaleSchema = z.object({
  region: z.string(),
  color_scale_id: z.number(),
  colors: z.array(z.string()),
});
export type LidarClearanceColorScale = z.infer<
  typeof LidarClearanceColorScaleSchema
>;

// One row of the region's lidar_type table - the point classification codes
// ds-lidar-pipeline's clearance rules compare a point's raw LAS
// `classification` column against.
export const LidarTypeSchema = z.object({
  region: z.string(),
  id: z.number(),
  name: z.string(),
  color: z.string(),
});
export type LidarType = z.infer<typeof LidarTypeSchema>;

export const LidarClearanceContextSchema = z.object({
  region_tags: z.array(z.string()),
  systems: z.array(LidarClearanceSystemSchema),
  axes: z.array(LidarClearanceAxisSchema),
  system_axes: z.array(LidarClearanceSystemAxisSchema),
  color_scales: z.array(LidarClearanceColorScaleSchema),
  lidar_types: z.array(LidarTypeSchema),
});
export type LidarClearanceContextData = z.infer<
  typeof LidarClearanceContextSchema
>;
